import { render, staticRenderFns } from "./CommentNotification.vue?vue&type=template&id=587203ad&scoped=true&"
import script from "./CommentNotification.vue?vue&type=script&lang=js&"
export * from "./CommentNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587203ad",
  null
  
)

export default component.exports